module.exports = __webpack_public_path__ + "img/ExpertThinkTank.a3ded406.png";